import script from "./AppNewHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNewHeader.vue?vue&type=script&setup=true&lang=js"

import "./AppNewHeader.vue?vue&type=style&index=0&id=1363f76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1363f76c"]])

export default __exports__